import {
  addYears,
  eachYearOfInterval,
  format,
  formatDistanceToNow,
  formatRelative,
  isValid,
  parseISO,
} from 'date-fns'

import { format as formatTz, toZonedTime } from 'date-fns-tz'
import { ptBR } from 'date-fns/locale'

export const formatDate = (date: string, toFormat: string) => {
  if (!date) return ''

  const zonedDate = toZonedTime(date, 'UTC')

  return formatTz(zonedDate, toFormat, {
    locale: ptBR,
    timeZone: 'UTC',
  })
}


export const formatDateSPZoned = (date: string, toFormat: string) => {
  if (!date) return ''

  const zonedDate = toZonedTime(date, 'America/Sao_Paulo')

  return formatTz(zonedDate, toFormat, {
    locale: ptBR,
    timeZone: 'America/Sao_Paulo',
  })
}

/**
 * Get current date and return in a forma extensive
 * @example Quarta-feira, 24 Janeiro
 * @returns string
 */
export const getExtensiveCurrentDay = () => {
  const month = formatDate(new Date().toISOString(), `LLLL`)

  const day = formatDate(new Date().toISOString(), `EEEE`)

  const today = `${day[0]?.toUpperCase() + day.slice(1)}, ${formatDate(new Date().toISOString(), 'dd')} de ${
    month[0]?.toUpperCase() + month.slice(1)
  }`

  return today
}

/**
 * Returns a shortened date string in the format 'day month year'.
 *
 * @param {string} date - The date to be formatted.
 * @return {string} The shortened date string.
 */
export const getShortDate = (date: string, withYear = true) => {
  if (!date) return ''

  try {
    const [day, month, year] = formatDate(date, `dd MMM yy`).split(' ')

    return `${day} ${month[0].toUpperCase() + month.substring(1)} ${withYear ? year : ''}`
  } catch (e) {
    console.log(e)

    return ''
  }
}

const formatRelativeLocale = {
  yesterday: "'Ontem'",
  today: "'Hoje'",
  tomorrow: "'Amanhã'",
  nextWeek: 'dd MMM',
  lastWeek: 'dd MMM',
  other: 'dd MMM',
}

const locale = {
  ...ptBR,
  formatRelative: (token: keyof typeof formatRelativeLocale) =>
    formatRelativeLocale[token],
}

/**
 * Returns the relative day of the given date.
 *
 * @param {string} day - The date to be formatted.
 * @return {string} The relative day string.
 */
export const getRelativeDay = (day: string) =>
  formatRelative(parseISO(day?.replace('Z', '')), new Date(), {
    locale,
    weekStartsOn: 0,
  })

export const getDistanceFromNow = (date: string) => {
  const parsed = parseISO(date?.replace('Z', ''))

  if (!isValid(parsed)) return ''

  return `há ${formatDistanceToNow(parsed, { locale })}`
}

export const allMonths = [
  {
    value: '01',
    title: 'Janeiro',
  },
  {
    value: '02',
    title: 'Fevereiro',
  },
  {
    value: '03',
    title: 'Março',
  },
  {
    value: '04',
    title: 'Abril',
  },
  {
    value: '05',
    title: 'Maio',
  },
  {
    value: '06',
    title: 'Junho',
  },
  {
    value: '07',
    title: 'Julho',
  },
  {
    value: '08',
    title: 'Agosto',
  },
  {
    value: '09',
    title: 'Setembro',
  },
  {
    value: '10',
    title: 'Outubro',
  },
  {
    value: '11',
    title: 'Novembro',
  },
  {
    value: '12',
    title: 'Dezembro',
  },
]

export const getIntervalOfYears = (limit = 10) => {
  const today = new Date()

  const result = eachYearOfInterval({
    start: today,
    end: addYears(today, limit),
  })

  return result.map((item) => {
    const value = format(item, 'yyyy', { locale: ptBR })

    return {
      title: value,
      value,
    }
  })
}
